import request from "@/utils/request";

//
export function get_all_map_source(data) {
  return request({
    url: "/api-ierp/ierpext/kapi/v2/dknm/dknm_b_basedata/dknm_map_source/dknm_map_source_new",
    method: "post",
    data: data,
  });
}
export function get_dknm_assistantdata_detail(data) {
  return request({
    url: "/api-ierp/ierpext/kapi/v2/dknm/base/bos_assistantdata_detail/dknm_assistantdata_detail",
    method: "post",
    data: data,
  });
}
